<template>
  <client-blank-form
    submit-label="Добавить клиента"
    :client="client"
    :errors="errors"
    form-type="add"
    @submit="processClientForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addClient } from '@/services/client.service'
import clientBlankForm from '@/components/forms/client/ClientBlankForm'

export default {
  name: 'client-add-form',
  components: { clientBlankForm },
  props: {
    apartment: {
      type: [Number]
    }
  },
  data () {
    return {
      client: {
        id: null,
        first_name: '',
        last_name: '',
        middle_name: '',
        phone: '',
        contract_number: '',
        apartment: this.apartment,
        rate_plan: '',
        discount: ''
      },

      errors: {
        client: {
          id: [],
          first_name: [],
          last_name: [],
          middle_name: [],
          phone: [],
          contract_number: [],
          apartment: [],
          rate_plan: [],
          discount: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processClientForm () {
      this.addClient().then((success) => {
        if (success) {
          this.showMsg('Клиент был успешно добавлен!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addClient () {
      return addClient(this.client).then((response) => {
        this.client = response.data
        this.fillErrors(this.errors.client, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.client, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClientAddForm.vue?88090cec